export default function getAllRecipes() {
  let allRecipes = [];

  const importAll = (r) => r.keys().map(r);
  const allRecipeModules = importAll(require.context('../recipes', true, /recipe\.js$/));

  allRecipeModules.forEach(recipeModule => {
    const recipeObject = {
      id: recipeModule.recipe.intro.id,
      recipe: recipeModule.recipe
    }
    
    allRecipes.push(recipeObject)
  })

  console.log(allRecipes);
}
